import axios from "axios";

import apiUrl from "../../Services/apiUrls";
import * as actionTypes from "./actionTypes";

const mostPopularStart = () => {
  return {
    type: actionTypes.MOST_POPULAR_START,
  };
};

const mostPopularSuccess = (mostViewed) => {
  return {
    type: actionTypes.MOST_POPULAR_SUCCESS,
    mostViewed: mostViewed,
  };
};

const mostPopularFailure = () => {
  return {
    type: actionTypes.MOST_POPULAR_FAILURE,
  };
};

export const mostPopular = () => {
  return (dispatch) => {
    dispatch(mostPopularStart());
    console.log("apiUrl: ", apiUrl.mostViewed);
    axios
      .get(apiUrl.mostViewed)
      .then((response) => {
        dispatch(mostPopularSuccess(response.data.results));
      })
      .catch((error) => {
        console.log(error);
        dispatch(mostPopularFailure());
      });
  };
};



// WEBPACK FOOTER //
// ./src/Store/actions/popularStories.js